module.exports = __webpack_public_path__ + "static/media/doTERRA-share-guide.f6d2208a.pdf";